const edu = {
 "about": {
  "whatH": "Qué es",
  "whatB": "FluentLoop para la Educación ofrece al profesorado y al alumnado de un centro la práctica de idiomas con IA de GetFluentLoop, además de clases y tareas para el profesorado.",
  "pilotH": "El piloto",
  "pilotB": "Los centros verificados reciben un piloto gratuito de 90 días. Sin tarjeta de crédito, y nunca se convierte por sí solo en un plan de pago.",
  "whoH": "Para quién es",
  "whoB": "Colegios, universidades, escuelas de idiomas y otras instituciones educativas; lo solicita un docente o un responsable del centro.",
  "getH": "Qué obtienes",
  "getB": "Clases con enlaces de acceso, misiones y tareas, y vistas del progreso de la clase para el profesorado.",
  "privacyH": "Privacidad",
  "privacyB": "El profesorado solo ve el trabajo de clase. Las conversaciones personales con Fluent Friend, los diarios y el historial de aprendizaje privado del alumnado siguen siendo privados. Nunca guardamos fotos ni voz en bruto.",
  "howH": "Cómo funciona",
  "howB": "Envía tu solicitud abajo. Nuestro equipo revisa cada solicitud; enviarla es una petición, no una aprobación automática. Verás el estado aquí."
 },
 "publicSub": "Un piloto gratuito de 90 días para centros verificados.",
 "signupCta": "Crea una cuenta para solicitarlo",
 "signinCta": "Iniciar sesión",
 "returnHint": "Volverás directamente aquí para enviar la solicitud después de iniciar sesión.",
 "intro": "Ofrece a tu alumnado un trimestre completo de práctica de fluidez con IA: gratis para centros verificados y sin tarjeta de crédito.",
 "status": {
  "pending_review": "En revisión",
  "needs_information": "Se ha pedido más información",
  "approved": "Aprobada",
  "rejected": "No aprobada"
 },
 "approvedLine": "Tu centro ya tiene acceso a FluentLoop Education. ¡Que lo disfrutes!",
 "teacherLink": "Abrir el panel del profesorado →",
 "reviewerNote": "Nota del revisor: {note}",
 "submittedOn": "Enviada el {date}. Enviar una solicitud es una petición, no una aprobación automática.",
 "rejectedDefault": "Tu solicitud para el centro no ha sido aprobada por el momento.",
 "resubmit": "Puedes enviar una nueva solicitud abajo.",
 "f": {
  "name": "Nombre de la institución *",
  "type": "Tipo de institución",
  "country": "País",
  "website": "Sitio web de la institución",
  "email": "Tu correo del centro / del trabajo",
  "role": "Tu función",
  "learners": "Número aproximado de estudiantes",
  "notes": "Nota breve (opcional)",
  "notesPh": "Cuéntanos un poco sobre tu programa.",
  "disclaimer": "Sin tarjeta de crédito. Nunca recopilamos datos del alumnado. El envío es una solicitud que revisa nuestro equipo, no una aprobación automática."
 },
 "types": {
  "school": "Colegio / instituto",
  "university": "Universidad",
  "language_school": "Escuela de idiomas",
  "training_center": "Centro de formación",
  "educational_nonprofit": "Organización educativa sin ánimo de lucro",
  "other_education": "Otra institución educativa"
 },
 "roles": {
  "teacher": "Docente",
  "school_admin": "Administración del centro",
  "principal": "Dirección",
  "director": "Director/a",
  "coordinator": "Coordinación",
  "other": "Otro"
 },
 "toast": {
  "needName": "Introduce el nombre de tu institución.",
  "alreadyOpen": "Ya tienes una solicitud en revisión.",
  "submitted": "¡Solicitud enviada!",
  "failed": "No se pudo enviar la solicitud."
 },
 "attest": "Confirmo que presento esta solicitud en mi función profesional como docente o representante autorizado del centro.",
 "attestNeeded": "Confirma la declaración como docente.",
 "vTitle": "Necesitamos un poco más de información",
 "vIntro": "Para verificar tu función en el centro, comparte:",
 "proofs": {
  "institutional_email": "Tu correo institucional (del centro)",
  "staff_page": "Un enlace a una página oficial del personal en la que aparezcas",
  "school_admin_confirmation": "Una confirmación de la administración de tu centro",
  "other": "Otra prueba de tu vínculo con el centro"
 },
 "vEmail": "Correo institucional",
 "vEmailHint": "Solo se usa como prueba. Tu correo de inicio de sesión no cambia.",
 "vUrl": "Enlace a la página oficial del personal",
 "vNote": "Nota breve",
 "vSend": "Enviar información",
 "vReceived": "Gracias, hemos recibido tu información. Tu solicitud sigue en revisión.",
 "vSent": "Información enviada.",
 "vFailed": "No se pudo enviar tu información.",
 "ev": {
  "submitted": "Solicitud enviada",
  "requested": "Se ha pedido más información",
  "response": "Información recibida"
 }
};
Object.assign(edu, {
 "approvedOnly": "Aprobada el {date}",
 "approvedActive": "Aprobada el {date} · Piloto escolar activo hasta el {end}",
 "approvedEnded": "Aprobada el {date} · El piloto escolar terminó el {end}",
 "teach": {
  "welcome": "Bienvenido/a a FluentLoop for Education",
  "pilotActive": "Piloto educativo activo · Termina el {date}",
  "pilotEnded": "El piloto educativo terminó el {date}",
  "pilotInactive": "Piloto educativo no activo",
  "next": "Empieza creando una clase para el idioma que enseñas. Recibirás un código y un enlace para compartir con tus estudiantes.",
  "createFirst": "Crea tu primera clase",
  "howLink": "Cómo funciona FluentLoop for Education",
  "s1H": "Crea una clase", "s1B": "Elige el idioma y el nivel.",
  "s2H": "Invita a tus estudiantes", "s2B": "Comparte el código o el enlace de la clase. Cada estudiante se une con su propia cuenta.",
  "s3H": "Asigna y enseña", "s3B": "Crea Misiones de Fluidez y asígnalas a tu clase.",
  "s4H": "Sigue el progreso de la clase", "s4B": "Consulta las tareas completadas y la actividad de la clase.",
  "canSeeH": "Lo que el profesorado puede ver",
  "canSee": "Quién está en la clase|Tareas asignadas completadas|Actividad del centro y de la clase|Resultados de tus lecciones y tareas",
  "cantSeeH": "Lo que el profesorado no puede ver",
  "cantSee": "Conversaciones privadas con Fluent Friend|Diario|Evidencias privadas de aprendizaje|Práctica personal de entrevistas|Aprendizaje personal no relacionado",
  "learnMore": "Más información sobre FluentLoop for Education",
  "missionLibrary": "Biblioteca de misiones",
  "createBtn": "Crear clase",
  "cancel": "Cancelar",
  "newClass": "Nueva clase",
  "name": "Nombre de la clase",
  "namePh": "p. ej., Español A1 — Grupo 2",
  "lang": "Idioma que se aprende",
  "level": "Nivel (MCER)",
  "desc": "Descripción (opcional)",
  "needOrg": "Necesitas un centro para crear una clase.",
  "needName": "Escribe un nombre para la clase.",
  "created": "Clase creada",
  "failed": "Algo salió mal. Inténtalo de nuevo.",
  "activeClasses": "Clases activas",
  "activeStudents": "Estudiantes activos",
  "schools": "Centros",
  "noClasses": "Todavía no hay clases activas.",
  "students": {"one": "{count} estudiante", "other": "{count} estudiantes"},
  "code": "Código",
  "archived": "Archivadas",
  "notTeacher": "Todavía no eres docente de ningún centro.",
  "apply": "Solicítalo en FluentLoop for Education",
  "requestContinuation": "Solicitar continuación",
  "continuationPending": "Continuación solicitada",
  "continuationSent": "Continuación solicitada. Nuestro equipo la revisará."
 },
 "cls": {
  "expiredH": "Piloto educativo vencido",
  "expiredB": "Las clases y tareas existentes siguen disponibles, pero no se puede crear trabajo escolar nuevo hasta que se renueve el acceso a Education.",
  "studentExpired": "El acceso a Education de este centro ha terminado, así que ahora no pueden unirse estudiantes nuevos. Tu cuenta personal de FluentLoop no se ve afectada.",
  "archive": "Archivar", "restore": "Restaurar",
  "invite": "Invitar a estudiantes", "classCode": "Código de clase",
  "copyCode": "Copiar código", "newCode": "Nuevo código", "copyLink": "Copiar enlace de invitación", "newLink": "Nuevo enlace",
  "showQr": "Mostrar código QR", "hideQr": "Ocultar código QR", "qrAlt": "Código QR del enlace de invitación a la clase",
  "qrNote": "Tus estudiantes pueden escanearlo para abrir el enlace de invitación. Se genera en este dispositivo.",
  "codeCopied": "Código copiado", "linkCopied": "Enlace copiado", "regenerated": "Se ha creado uno nuevo",
  "removed": "Estudiante retirado de la clase", "remove": "Retirar de la clase",
  "progressFailed": "No se pudo cargar el progreso.", "resultsFailed": "No se pudieron cargar los resultados.",
  "noAccess": "No tienes acceso a esta clase.",
  "roster": "Lista de clase ({n})", "noStudents": "Aún no hay estudiantes. Comparte el código o el enlace de arriba.", "joined": "Se unió el {date}",
  "progress": "Progreso",
  "privacyNote": "Solo trabajo de clase. El aprendizaje personal (Friend, Diario, vocabulario privado) nunca se muestra.",
  "aCompleted": "Tareas completadas", "inProgress": "En curso", "notStarted": "Sin empezar", "completed": "Completada",
  "lastActivity": "Última actividad en clase", "late": "(tarde)",
  "assignments": "Tareas", "createMission": "Crear misión",
  "noAssignments": "Aún no hay misiones asignadas. Crea una Misión de Fluidez para que tu clase practique.",
  "minutes": "~{n} min", "due": {"overdue": "vencida", "due_today": "vence hoy", "due_soon": "vence pronto"},
  "completedLower": "completadas",
  "insights": "Resumen de la clase", "completionRate": "Tasa de finalización", "participation": "Participación",
  "assignedWords": "Palabras asignadas que la clase aún está dominando", "needPractice": "Misiones que pueden necesitar más práctica",
  "pctDone": "{n}% hecho", "close": "Cerrar", "noStudentsInClass": "Aún no hay estudiantes en esta clase.",
  "joinTitle": "Unirse a una clase", "joinAuth": "Inicia sesión o crea tu cuenta gratuita de FluentLoop para unirte a esta clase.",
  "continue": "Continuar", "joinInvalid": "Esta invitación no es válida o ya no está activa.",
  "joinBtn": "Unirme a esta clase", "joining": "Uniéndote…", "joinedToast": "¡Te has unido a la clase!", "joinFailed": "No se pudo completar la unión."
 },
 "stu": {
  "intro": "Tus clases del centro. Tu aprendizaje personal en FluentLoop sigue separado y privado.",
  "none": "Todavía no estás en ninguna clase.",
  "unfinished": "{n} pendientes", "completedN": "{n} completadas", "pilotEndedTag": "Piloto terminado",
  "pilotEnded": "El piloto de FluentLoop Education de tu centro ha terminado. Tu cuenta personal de FluentLoop no cambia.",
  "haveCode": "¿Tienes un código de clase?", "joinWithCode": "¿Tienes un código de clase? Únete a una clase",
  "continue": "Continuar", "start": "Empezar", "teacher": "Docente",
  "assignments": "Tareas", "noAssignments": "Todavía no hay tareas.",
  "status": {"not_started": "Sin empezar", "in_progress": "En curso", "completed": "Completada"},
  "due": "Entrega: {date}", "classVocab": "Vocabulario de la clase",
  "privacy": "Tu docente solo ve tu trabajo en esta clase. Tu aprendizaje personal en FluentLoop sigue siendo privado.",
  "pendingCount": {"one": "{count} tarea del centro pendiente", "other": "{count} tareas del centro pendientes"},
  "signIn": "Inicia sesión para unirte", "signUp": "Crea una cuenta gratuita",
  "codeInvalid": "Ese código de clase no es válido. Compruébalo con tu docente.",
  "tooMany": "Demasiados intentos. Espera un minuto e inténtalo de nuevo.", "tryAgain": "Probar otro código"
 },
 "faq": {
  "title": "Preguntas y respuestas sobre Education",
  "g": {"schools": "Para centros y docentes", "privacy": "Privacidad y datos", "students": "Para estudiantes", "pilot": "Piloto y vencimiento"},
  "what": {"q": "¿Qué es FluentLoop for Education?", "a": "Una forma de que los centros usen FluentLoop con sus clases. El profesorado crea clases, asigna Misiones de Fluidez y sigue el progreso de la clase, y cada estudiante mantiene su propia cuenta privada de FluentLoop."},
  "pilot90": {"q": "¿Cómo funciona el piloto escolar de 90 días?", "a": "Tras la aprobación, tu centro tiene 90 días de FluentLoop Education sin coste. El profesorado y los estudiantes inscritos tienen acceso a Education mientras dura el piloto."},
  "whoApply": {"q": "¿Quién puede solicitarlo?", "a": "Docentes y personal autorizado de colegios, universidades, escuelas de idiomas y otras organizaciones educativas."},
  "verified": {"q": "¿Cómo se verifica al profesorado?", "a": "Nuestro equipo revisa cada solicitud. Antes de aprobarla, podemos pedirte un correo institucional o un enlace a una página oficial de personal del centro. Nadie se aprueba automáticamente."},
  "createClass": {"q": "¿Cómo creo una clase?", "a": "Abre el Panel docente, elige Crear clase e indica el nombre de la clase, el idioma y el nivel."},
  "studentsJoin": {"q": "¿Cómo se unen los estudiantes?", "a": "Comparte el código de 6 caracteres de la clase, su enlace de invitación o su código QR. Cada estudiante inicia sesión con su propia cuenta de FluentLoop y confirma la clase."},
  "roles": {"q": "¿Qué diferencia hay entre Docente y Administración del centro?", "a": "Cada docente gestiona sus propias clases. La administración del centro también puede gestionar todas las clases del centro y solicitar la continuación del piloto."},
  "continuation": {"q": "¿Cómo solicito la continuación del piloto?", "a": "Cuando el piloto se acerca a su fin, la administración del centro puede elegir Solicitar continuación en el Panel docente. Nuestro equipo revisa cada solicitud."},
  "teacherSee": {"q": "¿Qué puede ver el profesorado sobre los estudiantes?", "a": "Quién está en la clase, el progreso en el trabajo asignado en la clase, la actividad de la clase y los resultados de sus propias lecciones y tareas."},
  "teacherCant": {"q": "¿Qué no puede ver el profesorado?", "a": "Nada del aprendizaje personal del estudiante en FluentLoop: conversaciones con Fluent Friend, Diario, evidencias privadas de aprendizaje, vocabulario personal, práctica personal de entrevistas ni historial de práctica no relacionado."},
  "friendJournal": {"q": "¿Puede el profesorado ver las conversaciones con Fluent Friend o los Diarios?", "a": "No. Las conversaciones con Fluent Friend y las entradas del Diario son siempre privadas del estudiante."},
  "personalVocab": {"q": "¿Puede mi docente ver mi vocabulario personal?", "a": "No. El profesorado solo ve el progreso en el vocabulario asignado en su clase."},
  "joinWhat": {"q": "¿Qué pasa cuando me uno a una clase de FluentLoop?", "a": "La clase se añade a Mis clases y las tareas de tu docente aparecen allí y en tu Panel. No se comparte nada de tu cuenta personal."},
  "personalAccount": {"q": "¿Puedo seguir usando mi cuenta personal de FluentLoop?", "a": "Sí. Todo lo de tu cuenta sigue disponible, según tu cuenta y tu plan habituales."},
  "findClass": {"q": "¿Dónde encuentro mi clase?", "a": "Abre Más → Mis clases. Cada clase muestra tu centro, tu docente y tus tareas."},
  "findAssignments": {"q": "¿Dónde encuentro las tareas?", "a": "Dentro de cada clase en Mis clases. El trabajo escolar pendiente también aparece como una pequeña tarjeta en tu Panel."},
  "inviteLink": {"q": "¿Qué pasa cuando hago clic en un enlace de invitación a una clase?", "a": "Verás la clase y el centro y confirmarás que quieres unirte. Si aún no has iniciado sesión, primero inicias sesión o te registras y vuelves directamente a la clase."},
  "multiClass": {"q": "¿Puedo pertenecer a más de una clase?", "a": "Sí. Todas tus clases aparecen en Mis clases."},
  "leaveData": {"q": "¿Dejar o terminar una clase del centro borra mis datos personales de FluentLoop?", "a": "No. Tus datos personales de FluentLoop siguen en tu cuenta."},
  "pilotEnds": {"q": "¿Qué pasa cuando vence el piloto?", "a": "No se puede crear trabajo escolar nuevo: ni clases, ni tareas, ni misiones nuevas, y no pueden unirse estudiantes nuevos. No se borra nada y el acceso se reanuda si se renueva el piloto."},
  "finishAfter": {"q": "¿Pueden los estudiantes terminar las tareas existentes tras el vencimiento?", "a": "Sí. Los estudiantes que ya están en una clase pueden terminar las tareas asignadas antes de que terminara el piloto."},
  "dataAfter": {"q": "¿Qué pasa con las clases y los resultados tras el vencimiento?", "a": "Siguen disponibles para consultarlos. Las clases, listas, tareas y resultados no se borran."},
  "studentPilotEnds": {"q": "¿Qué pasa cuando termina el piloto de mi centro?", "a": "Puedes terminar el trabajo que tu docente ya había asignado. Tu cuenta personal de FluentLoop no cambia."}
 }
});
export default edu;
